<script>
export default {
    name: 'WhyScamPage'
};
</script>

<template>
    <section class="section-white container mx-auto max-w-5xl" style="box-shadow: 0 4px 24px 0 rgba(239, 68, 68, 0.25)">
        <div class="flex items-center gap-4 sm:flex-row flex-col">
            <i class="fi fi-ss-triangle-warning text-dashboard-lightRed mr-6" style="font-size: 6rem"></i>
            <div>
                <h2 class="text-2xl font-bold text-dashboard-lightRed uppercase mb-4">
                    {{ $t('whyScamPage.title') }}
                </h2>
                <p class="leading-relaxed mb-4">
                    {{ $t('whyScamPage.paragraph1', { count: 190 }) }}
                </p>
                <p class="leading-relaxed mb-4">
                    {{ $t('whyScamPage.paragraph2') }}
                </p>
                <p class="leading-relaxed">
                    {{ $t('whyScamPage.paragraph3') }}
                </p>
            </div>
        </div>
    </section>
</template>
